import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import { FilterConfigService, type FilterDataResult, SearchFilterModel } from '@ui/shared/util-filter';
import type { FoundingMapFilterKey } from '../../types/founding-map-filters';

@Injectable({ providedIn: 'root' })
export class SearchFilterConfigService extends FilterConfigService<FoundingMapFilterKey, undefined> {
    public override placeholder = 'Name der Neugründung, Workspaces oder Anlaufstelle';

    constructor() {
        super(
            new SearchFilterModel('search', 'Suchbegriff', []),
            undefined,
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return of({ data: [] });
    }
}
